import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ClientCell } from '../../../../common/ClientCell'
import { TruncatedValue } from '../../../../common/TruncatedValue'
import { formatMskDateTime } from '../../../matching/routes/Dashboard/core/mskTime'
import { formatSum } from '../../../../../utils'
import { PayoutRefusalListItem } from '../../../ticket-card/core/refusal.types'
import { payoutRefusalCardUrl } from '../core/consts'

/**
 * A row opens the refusal card. The click sits on the cells, not on the row: the client cell holds
 * its own link to the client card, and a row handler would open the refusal behind it as well.
 */
const PayoutRefusalsTable: React.FC<{ items: PayoutRefusalListItem[]; loading: boolean }> = ({ items, loading }) => {
  const navigate = useNavigate()

  return (
    <div className='table-responsive'>
      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-3'>
        <thead>
          <tr className='fw-bolder text-muted'>
            <th>Время (МСК)</th>
            <th>Мерчант</th>
            <th>ID транзакции</th>
            <th>Клиент</th>
            <th>Метод</th>
            <th className='text-end'>Сумма</th>
            <th>Причина</th>
            <th>Ответ мерчанту</th>
          </tr>
        </thead>
        <tbody>
          {items.map((row) => {
            const open = () => navigate(payoutRefusalCardUrl(row.id))

            return (
              <tr key={row.id} style={{ cursor: 'pointer' }}>
                <td onClick={open}>{formatMskDateTime(row.createdAt)}</td>
                <td onClick={open}>{row.merchant}</td>
                <td onClick={open}>
                  <TruncatedValue value={row.transactionId} />
                </td>
                <ClientCell externalId={row.client.externalId} token={row.client.token} />
                <td onClick={open}>{row.paymentMethod}</td>
                <td onClick={open} className='text-end text-nowrap'>
                  {formatSum(row.amount)} {row.currency}
                </td>
                <td onClick={open}>{row.reasonTitle}</td>
                <td onClick={open} className='text-muted' style={{ fontSize: 12 }}>
                  422 · {row.merchantResponse}
                </td>
              </tr>
            )
          })}
          {!loading && items.length === 0 && (
            <tr>
              <td colSpan={8} className='text-center text-muted'>
                Отказов нет
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default PayoutRefusalsTable
